import { render, staticRenderFns } from "./TextBoxPreview.vue?vue&type=template&id=0401efd7&scoped=true&"
import script from "./TextBoxPreview.vue?vue&type=script&lang=js&"
export * from "./TextBoxPreview.vue?vue&type=script&lang=js&"
import style0 from "./TextBoxPreview.vue?vue&type=style&index=0&id=0401efd7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401efd7",
  null
  
)

export default component.exports